export const OrganizationRelationType = {
  CLIENT: 'CLIENT',
  LANDLORD: 'LANDLORD',
  OEM: 'OEM',
} as const;

export type OrganizationRelationType =
  (typeof OrganizationRelationType)[keyof typeof OrganizationRelationType];
